import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, styled } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Loader } from 'packages/eid-ui'
import { ItemDetails, DeleteCredential } from 'components'
import { OverviewSection } from './OverviewSection'
import { MoreInformationSection } from './MoreInformationSection'
import CheckIn from 'components/DynamicComponents/CheckIn'
import CheckOut from 'components/DynamicComponents/CheckOut'
import { UIActionsList } from 'components/UIActions/UIActionsList'
import { CheckoutHistory } from './CheckoutHistory'
import useSubcomponents from 'useSubcomponents'
import { useQuery } from 'packages/core'
import { useHistory } from 'react-router'
import { getAccessibleTabs, updateUrlQueryParams } from 'utils'

const TABS = [
    {
        value: 'overview',
        label: 'Overview',
        display: true,
        requireAccess: {
            control:
                'ResourceAdmin-Application-Details-ClientSecret-Details-Overview',
        },
    },
    {
        value: 'additionalInformation',
        label: 'MoreInformation',
        display: true,
        requireAccess: {
            control:
                'ResourceAdmin-Application-Details-ClientSecret-Details-MoreInformation',
        },
    },
    {
        value: 'checkouts',
        label: 'Checkouts',
        display: true,
        requireAccess: {
            control:
                'ResourceAdmin-Application-Details-ClientSecret-Details-Checkouts',
        },
    },
]

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            display: 'flex',
            marginBottom: '16px',
            [theme.breakpoints.up('sm')]: {
                height: '80px',
                alignItems: 'center',
                position: 'relative',
            },
            [theme.breakpoints.down('md')]: {
                flexDirection: 'row',
                paddingTop: '16px !important',
                paddingBottom: '16px !important',
            },
        },
    }),
)

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})

const CertificateDetails = ({ certificate }) => {
    const { t } = useTranslation()
    const classes = useStyles()

    const { hasAccessToControl } = useSubcomponents()
    const query = useQuery()
    const history = useHistory()
    const [allAccessibleTabs, setAllAccessibleTabs] = useState([])
    const [activeTab, setActiveTab] = useState('')

    useEffect(() => {
        const activeTabInfo = getAccessibleTabs(
            query,
            history,
            TABS,
            query.get('drawerActiveTab'),
            null,
            hasAccessToControl,
            'drawerActiveTab',
            '',
        )
        setAllAccessibleTabs(activeTabInfo.allAccessibleTabs)
        setActiveTab(activeTabInfo.activeTab)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleTabChange = (tab) => {
        setActiveTab(tab)
        updateUrlQueryParams(
            query,
            history,
            [{ key: 'drawerActiveTab', value: tab }],
            [],
        )
    }

    return (
        <>
            {!certificate ? (
                <Loader />
            ) : (
                <>
                    <Box style={{ backgroundColor: '#fbfbfd' }}>
                        <ItemDetails.Tabs
                            variant="standard"
                            value={activeTab}
                            onChange={(_, value) => handleTabChange(value)}
                        >
                            {allAccessibleTabs.map((tab, index) => (
                                <ItemDetails.Tabs.Tab
                                    key={index + tab.value}
                                    value={tab.value}
                                    label={t(tab.label)}
                                    data-protectedsubcomponent={
                                        tab.requireAccess?.control
                                    }
                                />
                            ))}
                        </ItemDetails.Tabs>
                    </Box>

                    {activeTab === 'overview' && (
                        <OverviewSection certificate={certificate} />
                    )}
                    {activeTab === 'additionalInformation' && (
                        <MoreInformationSection certificate={certificate} />
                    )}
                    {activeTab === 'checkouts' && (
                        <CheckoutHistory certificate={certificate} />
                    )}
                    {!certificate.isExpired && (
                        <>
                            <UIActionsList item={certificate} />
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                            >
                                <PaddedDiv className={classes.root}>
                                    {certificate.canCheckOut && (
                                        <CheckOut
                                            data={{ item: certificate }}
                                            drawerView={true}
                                        />
                                    )}
                                    {certificate.canCheckIn && (
                                        <CheckIn
                                            data={{ item: certificate }}
                                            drawerView={true}
                                        />
                                    )}
                                    <Box
                                        style={{
                                            marginLeft:
                                                !certificate.canCheckIn &&
                                                !certificate.canCheckOut
                                                    ? '-40px '
                                                    : '0px',
                                        }}
                                    >
                                        <DeleteCredential
                                            item={certificate}
                                            drawerView={true}
                                        />
                                    </Box>
                                </PaddedDiv>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    )
}

export default CertificateDetails
